import GuestStatus from "./GuestStatus";

export default GuestStatus;
